import { letterHeadRepo } from "@/repositories/letterHeadRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetLetterHead = (tenantId: string, letterHeadId: string) => {
  return useObservable(
    () => letterHeadRepo.get(tenantId, letterHeadId),
    [tenantId, letterHeadId]
  );
};

export const useLetterHeadList = (tenantId: string) => {
  return useObservable(() => letterHeadRepo.list(tenantId), [tenantId]);
};
